import { createAction } from 'redux-actions';
import { makeActionType } from '../utils';

const namespace = 'NOTIFICATIONS';

export const fetchNotifications = createAction(makeActionType(namespace, ['FETCH']));
export const setNotifications = createAction(makeActionType(namespace, ['SET']));
